<script setup>
defineProps({
  href: {
    type: String,
    required: true
  },
  target: {
    type: String,
    default: "_self"
  },
  label: {
    type: String,
    required: true
  },
  active: {
    type: Boolean,
    default: false
  },
  account: {
    type: Boolean,
    default: false
  }
});
</script>

<template>
    <NuxtLink
        :to="href"
        :title="label"
        :target
        class="flex items-center md:space-x-2"
    >
        <button
            type="button"
            :class="[active && 'active', account && 'account']"
        >
            {{ label }}
        </button>
    </NuxtLink>
</template>

<style scoped>
img {
  @apply size-10 md:size-8 rounded hidden md:block;
}

button {
  @apply text-zinc-700 text-base font-normal leading-normal;
}
button:hover {
  @apply text-sky-500 text-base font-normal leading-normal;
}
button:active {
  @apply text-sky-700 text-base font-semibold leading-tight;
}
button:disabled {
  @apply text-zinc-400 text-base font-normal leading-normal;
}
button.active {
  @apply font-extrabold text-sky-700;
}
button.account {
  @apply transition-all duration-300 ease-in-out hover:bg-sky-400 bg-sky-500 rounded-md px-2.5 py-2 text-white leading-normal active:font-normal active:leading-normal;
}
button.account.active {
  @apply font-extrabold text-white;
}
</style>
